const config = {
  apiBaseUrl: 'https://backend.homeslygroup.com',
  apiBaseUrl1: 'http://51.89.150.131:8080',
  apiBaseUrl3: 'http://localhost:8080',
};

export default config;
